// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --consumer-stories-qualtrics-head-font-size: 21px;
}

.consumer-stories-qualtrics-slide {
  text-overflow: initial;
  white-space: normal;
  width: 1010px;
}

.consumer-stories-qualtrics-slide-contact {
  font-style: italic;
}

.consumer-stories-qualtrics-slide-buttons {
  height: 95px;
}

.consumer-stories-qualtrics-slide-content {
  height: 425px;
}

.consumer-stories-qualtrics-slide-contact > a {
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/slides/consumer-stories-qualtrics-slide/ConsumerStoriesQualtricsSlide.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[":root {\n  --consumer-stories-qualtrics-head-font-size: 21px;\n}\n\n.consumer-stories-qualtrics-slide {\n  text-overflow: initial;\n  white-space: normal;\n  width: 1010px;\n}\n\n.consumer-stories-qualtrics-slide-contact {\n  font-style: italic;\n}\n\n.consumer-stories-qualtrics-slide-buttons {\n  height: 95px;\n}\n\n.consumer-stories-qualtrics-slide-content {\n  height: 425px;\n}\n\n.consumer-stories-qualtrics-slide-contact > a {\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
